import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * Aweber Logo component
 *
 * @returns JSX.ELEMENT
 */
export const AweberLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 82.57 82.57" data-testid={dataTestId}>
      <path
        fill="#0079c1"
        d="M25.13,4.12h-.58A20.25,20.25,0,0,0,4.3,24.37V66.45A20.25,20.25,0,0,0,24.55,86.7h1.63A119.12,119.12,0,0,1,25.13,4.12Z"
        transform="translate(-4.3 -4.12)"
      />
      <path
        fill="#0079c1"
        d="M66.63,4.12h-27A105.42,105.42,0,0,0,40.87,86.7H66.63A20.25,20.25,0,0,0,86.88,66.45V24.37A20.25,20.25,0,0,0,66.63,4.12ZM53.94,81.57A3.52,3.52,0,0,1,49,80.9l0-.07h0A57.83,57.83,0,0,1,49,11h0a.35.35,0,0,1,0-.08,3.52,3.52,0,1,1,5.54,4.35l-.05,0h0a50.76,50.76,0,0,0,0,61.12h0a1.34,1.34,0,0,0,.11.14A3.51,3.51,0,0,1,53.94,81.57Zm13-10.13A2.37,2.37,0,0,1,63.61,71l-.06-.1h0a40.1,40.1,0,0,1,0-49.82h0a1.3,1.3,0,0,1,.1-.15,2.39,2.39,0,0,1,3.72,3l-.11.11A35.39,35.39,0,0,0,67.3,68l0,0,.11.12A2.36,2.36,0,0,1,66.94,71.44Z"
        transform="translate(-4.3 -4.12)"
      />
    </svg>
  );
};
